export default __webpack_public_path__ + "static/media/JPMC.972efce7.svg";